import React, { useEffect, useContext } from "react"

import gsap from "gsap"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import { ScreenContext } from "components/Providers/Screen"

import { ReactComponent as WhiteArrow } from "images/WhiteArrow.svg"
import Avatar from "images/Avatar.png"

import { horizontalLoop } from "utils/horizontalLoop"
import ContentWidth from "./ContentWidth"

const CustomerTestimonials = ({ content }) => {
  const { mobile } = useContext(ScreenContext)
  useEffect(() => {
    const testimonialsArr = gsap.utils.toArray(".testimonials")
    const testimonialLoop = horizontalLoop(testimonialsArr, { paused: true })

    document
      .querySelector(".next")
      .addEventListener("click", () =>
        testimonialLoop.next({ duration: 0.4, ease: "power1.inOut" })
      )
    document
      .querySelector(".prev")
      .addEventListener("click", () =>
        testimonialLoop.previous({ duration: 0.4, ease: "power1.inOut" })
      )
  }, [])

  const allTestimonials = content.testimonial.map(testimonial => (
    <TestimonialDiv className="testimonials">
      {!mobile && (
        <AvatarDiv>
          <AvatarImg alt="avatar" src={Avatar} />
          <ReviewerName>{testimonial.name}</ReviewerName>
        </AvatarDiv>
      )}
      <ContentDiv>
        <Testimonial largeQuote={testimonial.largeQuote}>
          “{testimonial.testimonial}”
        </Testimonial>
        {mobile && (
          <AvatarDiv>
            <AvatarImg alt="avatar" src={Avatar} />
            <ReviewerName>{testimonial.name}</ReviewerName>
          </AvatarDiv>
        )}
        <Stars
          alt={content?.rating?.altText}
          src={testimonial.rating.sourceUrl}
        />
      </ContentDiv>
    </TestimonialDiv>
  ))

  return (
    <BackgroundWrapper>
      <ContentWidth>
        <Wrapper>
          <TestimonialContainer>
            <LeftArrow className="prev" />
            <Content>
              <Header>How do customers rate their experience with us?</Header>
              <TestimonialContent>{allTestimonials}</TestimonialContent>
            </Content>
            <RightArrow className="next" />
          </TestimonialContainer>
        </Wrapper>
      </ContentWidth>
    </BackgroundWrapper>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Stars = styled.img`
  width: 20.278vw;
  height: 3.611vw;

  ${media.fullWidth} {
    width: 292px;
    height: 52px;
  }

  ${media.tablet} {
    width: 28.516vw;
    height: 5.078vw;
  }

  ${media.mobile} {
    width: 68.224vw;
    height: 12.15vw;
    margin-top: 4.673vw;
  }
`
const Testimonial = styled.p`
  ${props => (props.largeQuote ? text.h4 : text.h3)};
  color: ${colors.white};
  text-align: center;
  margin-bottom: 2.778vw;

  ${media.fullWidth} {
    margin-bottom: 40px;
  }

  ${media.tablet} {
    margin-bottom: 3.906vw;
  }

  ${media.mobile} {
    ${text.h3};
    margin-bottom: 4.673vw;
  }
`
const Header = styled.p`
  ${text.bodyLg};
  color: ${colors.white};
  text-align: center;

  ${media.mobile} {
    ${text.bodyMd};
  }
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* ${media.mobile} {
    flex-direction: column-reverse;
  } */
`
const ReviewerName = styled.p`
  ${text.bodyMd};
  color: ${colors.white};
`
const AvatarImg = styled.img`
  width: 7.639vw;
  height: 7.639vw;

  ${media.fullWidth} {
    width: 110px;
    height: 110px;
  }

  ${media.tablet} {
    width: 10.742vw;
    height: 10.742vw;
  }

  ${media.mobile} {
    width: 25.701vw;
    height: 25.701vw;
  }
`
const AvatarDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`
const TestimonialDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-width: 100%;
  min-height: 100%;
  gap: 2.083vw;
  margin-top: 1.389vw;

  ${media.fullWidth} {
    gap: 30px;
    margin-top: 20px;
  }

  ${media.tablet} {
    gap: 2.93vw;
    margin-top: 1.953vw;
  }

  ${media.mobile} {
    flex-direction: column-reverse;
    gap: 4.673vw;
    margin-top: 0px;
  }
`
const TestimonialContent = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: auto;
  width: 65.833vw;

  ${media.fullWidth} {
    width: 948px;
  }

  ${media.tablet} {
    width: 73.047vw;
  }

  ${media.mobile} {
    width: 75vw;
  }
`
const RightArrow = styled(WhiteArrow)`
  rotate: 180deg;
  width: 1.528vw;
  height: 2.361vw;

  ${media.fullWidth} {
    width: 22px;
    height: 34px;
  }

  ${media.tablet} {
    width: 2.148vw;
    height: 3.32vw;
  }

  ${media.mobile} {
    width: 5.14vw;
    height: 7.944vw;
  }
`
const LeftArrow = styled(WhiteArrow)`
  width: 1.528vw;
  height: 2.361vw;

  ${media.fullWidth} {
    width: 22px;
    height: 34px;
  }

  ${media.tablet} {
    width: 2.148vw;
    height: 3.32vw;
  }

  ${media.mobile} {
    width: 5.14vw;
    height: 7.944vw;
  }
`
const TestimonialContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(180deg, #583f99 0%, #3d2562 100%);
  width: 79.444vw;
  height: 22.292vw;
  border-radius: 1.667vw;
  gap: 2.5vw;

  ${media.fullWidth} {
    width: 1144px;
    height: 321px;
    border-radius: 24px;
    gap: 36px;
  }

  ${media.tablet} {
    width: 92.188vw;
    height: 28.418vw;
    border-radius: 2.344vw;
    gap: 3.516vw;
  }

  ${media.mobile} {
    height: auto;
    padding: 9.346vw 4.673vw;
    width: 90vw;
    border-radius: 5.607vw;
    gap: 0;
  }
`
const Wrapper = styled.div`
  height: auto;
  width: 100%;
  padding: 5.556vw 10.278vw;
  margin: -1px 0;

  ${media.fullWidth} {
    padding: 80px 148px;
  }

  ${media.tablet} {
    padding: 5.859vw 3.906vw;
  }

  ${media.mobile} {
    padding: 9.346vw 3.075vw;
  }
`

const BackgroundWrapper = styled.div`
  width: 100%;
`
export default CustomerTestimonials
